<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">

                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box full-width-reading">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <ul>
                                        <li><a href="#/visaprocess">Visa Process</a></li>
                                        <li><a href="#/appterms">Visa Application Terms</a></li>
                                        <li><a href="#/needvisa">Do I Need a Visa</a></li>
                                        <li><a href="#/req_photo">Photo Requirements</a></li>
                                        <li><a href="#/req_passport">Passport Requirements</a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">

                        </div>
                        <div class="col-8">
                            <div class="document top124">

                                <div class="row block">
                                    <div class="col-12">
                                        <h2>Temporarily Visa Application process is unavailable</h2>
                                     </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <ul>
                            <li><a href="#/visaprocess">Visa Process</a></li>
                            <li><a href="#/appterms">Visa Application Terms</a></li>
                            <li><a href="#/needvisa">Do I Need a Visa</a></li>
                            <li><a href="#/req_photo">Photo Requirements</a></li>
                            <li><a href="#/req_passport">Passport Requirements</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top32">
                    <div class="document">

                        <h2 class="bt-32">Temporarily Visa Application process is unavailable</h2>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'Temp',

        model: {},
        data: () => ({

        }),
        mounted() {


        },
        computed: {

        },
        methods: {
        }
    }
</script>

<style scoped>
</style>